import React, { useState } from "react";
import Axios from "axios";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import "../../css/style.css";
import Constant from "../Constant";

const paymentTypeOptions = [
  "registration",
  "event",
  "contest",
  "story",
  "poem",
];

const EditPayment = ({
  id,
  userName,
  paymentType,
  paymentFor,
  onClose,
  onUpdate,
}) => {
  const [formData, setFormData] = useState({
    userName: userName || "",
    paymentType: paymentType || "",
    paymentFor: paymentFor || "",
  });

  const updatePayment = async () => {
    try {
      const updatedFields = Object.keys(formData).reduce((acc, key) => {
        if (
          formData[key] !==
          (key === "userName"
            ? userName
            : key === "paymentType"
            ? paymentType
            : paymentFor)
        ) {
          acc[key] = formData[key];
        }
        return acc;
      }, {});

      if (Object.keys(updatedFields).length > 0) {
        await Axios.put(`${Constant.apiBasePath}payment/${id}`, updatedFields);
        if (onUpdate) onUpdate();
      }
      onClose();
    } catch (error) {
      console.error("Error updating payment", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    updatePayment();
  };

  return (
    <Popup open onClose={onClose} modal nested>
      <div className="popup-container">
        <h2>Edit Payment</h2>
        <form onSubmit={handleSubmit}>
          <label>
            Name:
            <input
              type="text"
              name="userName"
              value={formData.userName}
              onChange={handleChange}
            />
          </label>
          <label>
            Payment Type:
            <select
              name="paymentType"
              value={formData.paymentType}
              onChange={handleChange}
            >
              <option value="">Select Payment Type</option>
              {paymentTypeOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </label>
          <label>
            Payment For:
            <input
              type="text"
              name="paymentFor"
              value={formData.paymentFor}
              onChange={handleChange}
            />
          </label>
          <button type="submit">Update</button>
          <button type="button" onClick={onClose}>
            Cancel
          </button>
        </form>
      </div>
    </Popup>
  );
};

export default EditPayment;
